import { ReactNode } from 'react';
import { WithChildren } from 'src/utils/UtilityTypes';

interface Props extends WithChildren {
	title: string;
	titleEndElement?: ReactNode;
}

export default function PortfolioAccountsTableSection({
	title,
	titleEndElement,
	children,
}: Props) {
	return (
		<div className="flex flex-col gap-y-lg">
			<div className="flex items-center justify-between">
				<h2 className="typo-t2 text-text-default">{title}</h2>
				{titleEndElement}
			</div>

			{children}
		</div>
	);
}
